// @flow
import LocalStorageService from '../../services/localStorageService';
import clearSentryScope from '../sentry/clearSentryScope';

export default function logout() : void {
    LocalStorageService.removeToken();
    clearSentryScope();
}
